import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_chevron_sort.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-376fd990")

_pushScopeId("data-v-376fd990")
const _hoisted_1 = { class: "table-wrap" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "table-section",
      style: {
        maxHeight: `calc(calc(100vh / var(--viewport-scale)) - ${_ctx.substractHeight}px)`,
      }
    }, [
      _createVNode("table", null, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, index) => {
              return (_openBlock(), _createBlock("th", {
                key: `head-${col.name}-${index}`,
                style: { ...col.style },
                class: [{ collast: col.isAction }]
              }, [
                (!col.sortBy)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(col.name), 1)
                    ], 64))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "flex flex-row gap-2",
                      onClick: () => _ctx.onSort(col.sortBy)
                    }, [
                      _createVNode("div", null, _toDisplayString(col.name), 1),
                      (!_ctx.loading)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            (col.sortBy === _ctx.sortBy && _ctx.sortDirection === 'ASC')
                              ? (_openBlock(), _createBlock("img", _hoisted_2))
                              : (
                      col.sortBy === _ctx.sortBy && _ctx.sortDirection === 'DESC'
                    )
                                ? (_openBlock(), _createBlock("img", _hoisted_3))
                                : (_openBlock(), _createBlock("img", _hoisted_4))
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 8, ["onClick"]))
              ], 6))
            }), 128))
          ])
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock("tbody", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (item, i) => {
                return (_openBlock(), _createBlock("tr", {
                  key: `row-${i}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, idx) => {
                    return (_openBlock(), _createBlock("td", {
                      key: `col-${col.name}-${idx}`,
                      class: ["col", [{ collast: col.isAction }]],
                      style: { ...col.style }
                    }, [
                      (col.slotName && _ctx.$slots[col.slotName])
                        ? _renderSlot(_ctx.$slots, col.slotName, {
                            key: 0,
                            data: item,
                            index: i
                          }, undefined, true)
                        : (col.render)
                          ? (_openBlock(), _createBlock("span", {
                              key: 1,
                              class: col.render(item, i)?.class
                            }, _toDisplayString(col.render(item, i)?.text), 3))
                          : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                              (col.field === 'no')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.limit + i + 1), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(item[col.field] ?? "-"), 1)
                                  ], 64))
                            ], 64))
                    ], 6))
                  }), 128))
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("tbody", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from({ length: _ctx.pagination.limit }), (_item, i) => {
                return (_openBlock(), _createBlock("tr", {
                  key: `row-${i}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (col, idx) => {
                    return (_openBlock(), _createBlock("td", {
                      key: `col-${col.name}-${idx}`,
                      class: ["col", [{ collast: col.isAction }]],
                      style: { ...col.style }
                    }, [
                      _createVNode(_component_Skeleton)
                    ], 6))
                  }), 128))
                ]))
              }), 128))
            ]))
      ])
    ], 4),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PaginationV3, {
          key: 0,
          renderedData: _ctx.tableData.length,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          onSetPage: _ctx.setPage,
          paginationV3PaddingVertical: "py-1"
        }, null, 8, ["renderedData", "pagination", "onSetPage"]))
      : _createCommentVNode("", true)
  ]))
})